import { css } from "@emotion/css";

const styles = {
  filters: css`
    min-width: 4.3rem;
    min-height: 4rem;
    max-height: 4rem;
  `,
};

export default styles;
